import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import RegisterPage from "./pages/RegisterPage";
import AdminLogin from "./pages/AdminLogin";
import AuthCallback from "./pages/AuthCallback";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLearners from "./pages/AdminLearners";
import AdminPayments from "./pages/AdminPayments";
import AdminOnboarding from "./pages/AdminOnboarding";
import AdminCatalog from "./pages/AdminCatalog";
import AdminReports from "./pages/AdminReports";
import AdminAdmins from "./pages/AdminAdmins";
import AdminSettings from "./pages/AdminSettings";
import AdminAudit from "./pages/AdminAudit";
import { AuthProvider, RequireAuth } from "./lib/auth-context";

// Must sit INSIDE BrowserRouter to use useLocation().
// Intercepts the OAuth callback fragment BEFORE any ProtectedRoute runs,
// so the session is established first.
function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<RequireAuth><AdminDashboard /></RequireAuth>} />
      <Route path="/admin/learners" element={<RequireAuth><AdminLearners /></RequireAuth>} />
      <Route path="/admin/payments" element={<RequireAuth><AdminPayments /></RequireAuth>} />
      <Route path="/admin/onboarding" element={<RequireAuth><AdminOnboarding /></RequireAuth>} />
      <Route path="/admin/catalog" element={<RequireAuth><AdminCatalog /></RequireAuth>} />
      <Route path="/admin/reports" element={<RequireAuth><AdminReports /></RequireAuth>} />
      <Route path="/admin/admins" element={<RequireAuth owner><AdminAdmins /></RequireAuth>} />
      <Route path="/admin/settings" element={<RequireAuth owner><AdminSettings /></RequireAuth>} />
      <Route path="/admin/audit" element={<RequireAuth owner><AdminAudit /></RequireAuth>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
